/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersDefaultBudgetDto } from '../../models/users-default-budget-dto';

export interface UpdateDefaultBudgetValues$Params {
      body: Array<UsersDefaultBudgetDto>
}

export function updateDefaultBudgetValues(http: HttpClient, rootUrl: string, params: UpdateDefaultBudgetValues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UsersDefaultBudgetDto>>> {
  const rb = new RequestBuilder(rootUrl, updateDefaultBudgetValues.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UsersDefaultBudgetDto>>;
    })
  );
}

updateDefaultBudgetValues.PATH = '/budget-management/default-budget-value';
